import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9j5az29aau: FaireBrandEntity = {
  token: "b_9j5az29aau",
  type: "brand",
  name: "JOSSLYN by wall to wall",
  avatarUrl:
    "https://cdn.faire.com/fastly/dbb2d5f306d4ab9f34fa35679d4e69c85581b80f7eb9b658d1434ad6b8123183.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ca856efe382435ba88a3c4436e7dcf7dd6e026a11cfaab0918934fe65f9fc9f1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dbb2d5f306d4ab9f34fa35679d4e69c85581b80f7eb9b658d1434ad6b8123183.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ca856efe382435ba88a3c4436e7dcf7dd6e026a11cfaab0918934fe65f9fc9f1.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 750,
  isTopShop: true,
  isInsider: true,
  description:
    "In the world of fashion and self-expression, JOSSLYN by wall to wall accessories is here to help your boutique offer customers the perfect finishing touches to define their unique style. Our carefully curated accessories are designed to inspire self-expression, allowing your customers to tell their story, their way.  By partnering with us, you’ll gain access to a diverse selection of high-quality, trend-forward pieces at affordable prices—ensuring your boutique stays fresh, stylish, and ahead of the curve. Let’s work together to bring fashion and individuality to your customers every day!\n\nAt JOSSLYN by Wall to Wall Accessories, we are committed to quality, affordability, and a fresh approach to fashion. What sets us apart is our dedication to you—offering a diverse range of accessories and home products that not only look and feel exceptional but also fit seamlessly within your budget. With new arrivals added every week, we ensure your collection remains stylish, current, and full of fresh inspiration.\n\nYour success is our success.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:06.156Z",
    importedBy: "entity-db-cli",
  },
};
